<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Log Sistem</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              Log Sistem
            </div>
          </div>
        </div>

        <div class="section-body">
          <div class="card">
            <div class="card-header">
              <h4 class="d-inline">
                Log Sistem
              </h4>
              <div class="card-header-action">
                <button
                  id="btnRefresh"
                  class="btn btn-primary"
                  title="Refresh"
                  @click="loadPostsData"
                >
                  <i class="fa fa-sync" />
                </button>
              </div>
            </div>
            <div
              class="card-body"
              style="overflow:hidden"
            >
              <!-- COMPONENT YANG SUDAH KITA BUAT, MENGHARAPKAN 3 BUAH PROPS, YAKNI ITEMS, FIELDS DAN META. KETIGA DATA YANG DIMINTA OLEH PROPS INI AKAN KITA KIRIMKAN -->
              <!-- ADAPUN CARA MENGAMBIL VALUE DARI EMIT YANG SUDAH KITA BUAT ADALAH DENGAN MENAMBAHKAN @ DAN DIIKUTI DENGAN NAMA EMITNYA -->
              <!-- DAN PARAMETER SETELAH SAMA DENGAN DARI EMIT ADALAH FUNGSI UNTUK MENERIMA VALUENYA -->
              <LogTable
                :items="items" 
                :fields="fields" 
                :meta="meta" 
                :loading="tableLoading"
                @per_page="handlePerPage" 
                @pagination="handlePagination" 
                @search="handleSearch" 
                @sort="handleSort"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from './../layouts/Admin.vue'
import NProgress from 'nprogress'
import swal from 'sweetalert'
import LogTable from './../../components/table/LogTable.vue'

export default {
  name: 'Log',
  data() {
    return {
      fields: [
        { key: 'no', sortable: false },
        { key: 'nama_lengkap', label: 'Nama', sortable: true },
        { key: 'aksi', sortable: false },
        { key: 'keterangan', sortable: false },
        { key: 'created_at', label: 'Waktu', sortable: true }
      ],
      items: [],
      meta: {},
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'created_at',
      sortByDesc: true,
      tableLoading: true,
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  components: {
    LayoutAdmin, LogTable
  },
  methods: {
    loadPostsData() {
      this.tableLoading = true
      NProgress.start()
      let button = document.querySelector('#btnRefresh')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-sync"></i>'

      let current_page = this.search == '' ? this.current_page : 1

      let data = {
        page: current_page,
        per_page: this.per_page,
        q: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC' : 'ASC'
      }

      this.$store.dispatch('fetchLog', data).then((response) => {

        let date = ''
        let created_at = ''
        response.data.data.data.forEach(e => {
          date = new Date(e.created_at)
          created_at = date.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
          created_at += ' ' + date.toLocaleTimeString('it-IT')
          e.created_at = created_at

          switch (e.aksi) {
            case 1:
              e.aksi = 'Create'
              break
            case 2:
              e.aksi = 'Read'
              break
            case 3:
              e.aksi = 'Update'
              break
            case 4:
              e.aksi = 'Delete'
              break
          }
        })
        let getData = response.data.data
        this.items = getData.data
        this.meta = {
          total: getData.total,
          current_page: getData.current_page,
          per_page: getData.per_page,
          from: getData.from,
          to: getData.to
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
        NProgress.done()
        this.tableLoading = false
      })
    },
    handlePerPage(val) {
      this.per_page = val
      this.loadPostsData()
    },
    handlePagination(val) {
      this.current_page = val
      this.loadPostsData()
    },
    handleSearch(val) {
      this.search = val
      this.loadPostsData()
    },
    handleSort(val) {
      this.sortBy = val.sortBy
      this.sortByDesc = val.sortDesc

      this.loadPostsData()
    }
  },
  mounted() {
    this.loadPostsData()
  }
}
</script>